// components/business/message-container/components/content/text-info/text-info.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        innerText: {
            type: String,
            value: "",
            observer: function (data) {
                this.setData({
                    content: data,
                });
            },
        },
        feature: {
            type: Object,
            value: {},
            observer: function (data) {
                const { extObj } = data || {};
                const { quote } = extObj || {};
                this.setData({
                    quote,
                });
            },
        },
    },

    /**
     * 组件的初始数据
     */
    data: {
        content: "",
        quote: {},
    },

    /**
     * 组件的方法列表
     */
    methods: {},
});
